import {gql} from 'apollo-boost';

export const GET_STUDENTSTATUSES = gql`
  query getStudentStatuses{
    getStudentStatuses {
      id
      nameLocal
      nameEng
    }
  }
`;

export const GET_STUDENTSTATUS = gql`
  query getStudentStatus($id : ID!){
    getStudentStatus (
      id: $id
    ) {
      id
      nameLocal
      nameEng
    }
  }
`;

export const ADD_STUDENTSTATUS = gql`
  mutation addStudentStatus(
    $nameLocal: String!,
    $nameEng: String!,
  ) {
    addStudentStatus(
      nameLocal: $nameLocal
      nameEng: $nameEng
    ) {
      id
      nameLocal
      nameEng
    }
  }
`;

export const UPDATE_STUDENTSTATUS = gql`
  mutation updateStudentStatus(
    $id: ID!,
    $nameLocal: String!,
    $nameEng: String!,
  ) {
    updateStudentStatus(
      id: $id
      nameLocal: $nameLocal
      nameEng: $nameEng
    ) {
      id
      nameLocal
      nameEng
    }
  }
`;

export const DELETE_STUDENTSTATUS = gql`
  mutation deleteStudentStatus($id: ID!) {
    deleteStudentStatus(
      id: $id
    ) {
      id
      nameLocal
      nameEng
    }
  }
`;

